
// IMPORTANT - Dont publish internal modules.

export * from "./CognitiveSubscriptionKeyAuthentication";
export * from "./CognitiveTokenAuthentication";
export * from "./IAuthentication";
export * from "./IConnectionFactory";
export * from "./RecognitionEvents";
export * from "./Recognizer";
export * from "./RecognizerConfig";
export * from "./SpeechResults";
export * from "./WebsocketMessageFormatter";



// WEBPACK FOOTER //
// ../src/sdk/speech/Exports.ts